import { css } from '@utils/css';

const figure = css`
  margin: 0;
`;

export { figure };
//# sourceMappingURL=figure.js.map
